/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for regularAggregateType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="regularAggregateType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="none"/&gt; &lt;enumeration value="average"/&gt; &lt;enumeration value="automatic"/&gt; &lt;enumeration value="calculated"/&gt; &lt;enumeration value="count"/&gt; &lt;enumeration value="countDistinct"/&gt; &lt;enumeration value="countNonZero"/&gt; &lt;enumeration value="maximum"/&gt; &lt;enumeration value="median"/&gt; &lt;enumeration value="minimum"/&gt; &lt;enumeration value="standardDeviation"/&gt; &lt;enumeration value="total"/&gt; &lt;enumeration value="variance"/&gt; &lt;enumeration value="doNotUse"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class RegularAggregateType extends Enum{

	enumValue = null;

	/**
	 * This item should be used as a grouping item.
	 */
	static  NONE = RegularAggregateType.newLiteral("none");

	/**
	 * Compute the average value for the values of the group.
	 */
	static  AVERAGE = RegularAggregateType.newLiteral("average");

	/**
	 * The aggregation rule is determined automatically at run time.
	 */
	static  AUTOMATIC = RegularAggregateType.newLiteral("automatic");

	/**
	 * Aggregation is performed on the elements before the rest of the expression is executed. For example, if the aggregate rule for Q1_a is set to total, and the rule for q1_b is set to average, then if this query item is based on the expression (QI_a / QI_b) * 100, the aggregate is computed as: ( total(QI_a)  / average( QI_b ) ) * 100.
	 */
	static  CALCULATED = RegularAggregateType.newLiteral("calculated");

	/**
	 * Compute the number of the values of the group.
	 */
	static  COUNT = RegularAggregateType.newLiteral("count");

	/**
	 * Compute the number of distinct values in the group.
	 */
	static  COUNT_DISTINCT = RegularAggregateType.newLiteral("countDistinct");

	/**
	 * Compute the number of the values of the group, excluding zero and NULL values.
	 */
	static  COUNT_NON_ZERO = RegularAggregateType.newLiteral("countNonZero");

	/**
	 * Compute the maximum value of the values of the group.
	 */
	static  MAXIMUM = RegularAggregateType.newLiteral("maximum");

	/**
	 * Compute the median value of the values of the group.
	 */
	static  MEDIAN = RegularAggregateType.newLiteral("median");

	/**
	 * Compute the minimum value of the values of the group.
	 */
	static  MINIMUM = RegularAggregateType.newLiteral("minimum");

	/**
	 * Compute the standard deviation value of the values of the group.
	 */
	static  STANDARD_DEVIATION = RegularAggregateType.newLiteral("standardDeviation");

	/**
	 * Compute the sum of the values of the group.
	 */
	static  TOTAL = RegularAggregateType.newLiteral("total");

	/**
	 * Compute the variance value of the values of the group.
	 */
	static  VARIANCE = RegularAggregateType.newLiteral("variance");

	/**
	 * The related item must not be used as a grouping item and must not be aggregated. This value is used for the item that represents the property of a level of a dimension.
	 */
	static  DO_NOT_USE = RegularAggregateType.newLiteral("doNotUse");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < RegularAggregateType.values().length); ++i) {
			if (RegularAggregateType.values()[i].enumValue == v) {
				return RegularAggregateType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("RegularAggregateType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/RegularAggregateType.js